import { Link } from 'react-router-dom';

function resolveInternalAppPath(href) {
  if (!href || typeof href !== 'string') return null;

  if (href.startsWith('/') && !href.startsWith('//')) {
    if (href.startsWith('/api/')) return null;
    return href;
  }

  try {
    const url = new URL(href);
    if (url.origin !== window.location.origin) return null;
    const path = `${url.pathname}${url.search}${url.hash}`;
    if (!path.startsWith('/') || path.startsWith('/api/')) return null;
    return path;
  } catch {
    return null;
  }
}

export default function ChatMarkdownLink({ href, children, ...rest }) {
  const internalPath = resolveInternalAppPath(href);

  if (internalPath) {
    return (
      <Link
        to={internalPath}
        {...rest}
        style={{ color: 'var(--mui-palette-primary-main, #1677ff)', textDecoration: 'underline', fontWeight: 600 }}
      >
        {children}
      </Link>
    );
  }

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" {...rest}>
      {children}
    </a>
  );
}
